/**
 * Helper functions for comparing schema versions of the form MAJOR.MINOR.BUILD
 * @module
 */

function parseVersion(version: string): number[] {
  return version.split(".").map((x) => parseInt(x));
}

function compareVersion(versionA: string, versionB: string) {
  const aParts = parseVersion(versionA);
  const bParts = parseVersion(versionB);

  for (let i = 0; i < 3; i++) {
    const diff = aParts[i] - bParts[i];
    if (diff !== 0) {
      return diff;
    }
  }

  return 0;
}

export function schemaVersionGreaterThan(versionA: string, versionB: string) {
  return compareVersion(versionA, versionB) > 0;
}

export function schemaVersionGreaterThanOrEqualTo(versionA: string, versionB: string) {
  return compareVersion(versionA, versionB) >= 0;
}

export function schemaVersionLessThanOrEqualTo(versionA: string, versionB: string) {
  return compareVersion(versionA, versionB) <= 0;
}
